var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dialogRoot",
      staticClass: "selectFilterDialogRoot",
      attrs: {
        role: "dialog",
        "aria-labelledby": "textInputMsgTitle",
        "aria-describedby": "textInputMsg"
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "dialogBody" }, [
        _c("div", { staticClass: "inputWrapper" }, [
          _vm.error
            ? _c("div", { staticClass: "error" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.error) + "\n\t\t\t\t"),
                _c("div", { staticClass: "tryAgain" }, [
                  _c("input", {
                    attrs: { type: "button", value: "Try Again" },
                    on: { click: _vm.loadFilterSummaries }
                  })
                ])
              ])
            : _vm.loading || _vm.filterSummaries
            ? _c("div", [
                _vm.filterSummaries && _vm.filterSummaries.length
                  ? _c(
                      "div",
                      { staticClass: "filterSummaryList" },
                      _vm._l(_vm.filterSummaries, function(f) {
                        return _c(
                          "a",
                          {
                            key: f.filter.FilterId,
                            ref: "filterNodes",
                            refInFor: true,
                            staticClass: "filterNode",
                            attrs: { role: "button", tabindex: "0" },
                            on: {
                              click: function($event) {
                                return _vm.selectFilter(f.filter)
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "filterName",
                              domProps: { textContent: _vm._s(f.filter.Name) }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "filterMeta" }, [
                              _vm._v(
                                "[" +
                                  _vm._s(f.NumConditions) +
                                  " Conditions, " +
                                  _vm._s(f.NumActions) +
                                  " Actions]"
                              )
                            ]),
                            _vm._v(" "),
                            f.filter.Enabled
                              ? _c(
                                  "span",
                                  { staticClass: "filterMeta filterEnabled" },
                                  [_vm._v("[Enabled]")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !f.filter.Enabled
                              ? _c(
                                  "span",
                                  { staticClass: "filterMeta filterDisabled" },
                                  [_vm._v("[Disabled]")]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filterSummaries && _vm.filterSummaries.length === 0
                  ? _c("div", [
                      _vm._v("This project does not have any filters yet.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.loading
                  ? _c("div", { staticClass: "loadingOverlay" }, [
                      _c(
                        "div",
                        { staticClass: "loading" },
                        [_c("ScaleLoader"), _vm._v(" Loading…")],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _c("div", [
                _vm._v(
                  "\n\t\t\t\tFailed to load filter list for project: " +
                    _vm._s(_vm.projectName) +
                    "\n\t\t\t\t"
                ),
                _c("div", { staticClass: "tryAgain" }, [
                  _c("input", {
                    attrs: { type: "button", value: "Try Again" },
                    on: { click: _vm.loadFilterSummaries }
                  })
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "div",
          {
            staticClass: "dialogButton cancelButton",
            attrs: { tabindex: "0" },
            on: {
              click: _vm.cancelClicked,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ]) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.cancelClicked($event)
              }
            }
          },
          [_vm._v("\n\t\t\tCancel\n\t\t")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBar" }, [
      _c(
        "div",
        {
          staticClass: "title",
          attrs: { id: "textInputMsgTitle", role: "alert" }
        },
        [_vm._v("Select a Filter")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }